import ActionPanel from '@/components/ActionPanel';
import PageContent from '@/components/PageContent';
import { EventTypeEnum, ScrapedEvent } from '@/models/scraped-event.model';
import React, { useState } from 'react';
import { PanelGroup } from 'rsuite';
import ApproveScrapedMarathonModal from './approve-scraped-marathon-modal';
import { toastErrorMessage } from '@/utils/toasterMessage';
import ApproveScrapedRunEventModal from './approve-scraped-run-event-modal';



interface ScrapedEventActionsProps{
    formObject?: ScrapedEvent;
    fetchData: () => void;
};

const ScrapedEventActions: React.FC<ScrapedEventActionsProps> = ({formObject, fetchData}) => {
  const [openApproveMarathonModal, setOpenApproveMarathonModal] = useState(false);
  const [openApproveRunEventModal, setOpenApproveRunEventModal] = useState(false);

  const handleClickApprove = () => {
    if(formObject?.eventType == EventTypeEnum.Marathon){
      setOpenApproveMarathonModal(true);
    }else if(formObject?.eventType == EventTypeEnum.RunEvent || formObject?.eventType == EventTypeEnum.Trail || formObject?.eventType == EventTypeEnum.Hyrox){
      setOpenApproveRunEventModal(true);
    } else {
      toastErrorMessage("Type of scraped event is undefined.");
    }
  };

    return (
        <PageContent>
            <PanelGroup>
                <ActionPanel
                  title={'Approve'}
                  description='This action updates the approval status of a scraped event. Based on the event type, it will generate the corresponding event entity. For example, if the event type is Marathon, a Marathon event entity will be created.'
                  onClick={handleClickApprove}
                  disabled={formObject?.isApproved}
                />
            </PanelGroup>
            <ApproveScrapedMarathonModal
              formObject={formObject}
              open ={openApproveMarathonModal}
              onClose={()=> {
                setOpenApproveMarathonModal(false);
                fetchData();
              }}
            />
            <ApproveScrapedRunEventModal
              formObject={formObject}
              open ={openApproveRunEventModal}
              onClose={()=> {
                setOpenApproveRunEventModal(false);
                fetchData();
              }}
            />
        </PageContent>
    );
};

export default ScrapedEventActions;
